import { render, staticRenderFns } from "./App.html?vue&type=template&id=5e1dd22a&shadow"
import script from "./App.ts?vue&type=script&lang=ts&shadow"
export * from "./App.ts?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./App.scss?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports